import { getRulePointAndIssueStatus, getCustomerRulePointAndIssueStatus } from "@utils/api.js"

if (!customElements.get("v5-membership-get-benefit")) {
  customElements.define("v5-membership-get-benefit", class V5MembershipGetBenefit extends HTMLElement {
    constructor() {
      super()
    }
    async connectedCallback() {
      if (window.pageInfo?.customerInfo?.id) {
        this.getLoggedStatus()
      } else {
        const res = await getRulePointAndIssueStatus()
        const data = res.data || {}
        const pointsMap = this.buildPointsMap(data)
        this.pointsMap = pointsMap
        this.issuedMap = null

        this.fillBenefitSlots(pointsMap)
      }
    }
    async getLoggedStatus(types = []) {
      const hasTypes = Array.isArray(types) && types.length > 0
      const maxAttempts = hasTypes ? 6 : 1
      const delay = (ms) =>
        new Promise((resolve) => {
          setTimeout(resolve, ms)
        })

      for (let attempt = 1; attempt <= maxAttempts; attempt += 1) {
        const res = await getCustomerRulePointAndIssueStatus()
        const data = res.data || {}
        const { issuedRegister, issuedEmail, issuedSms, issuedFillBirthday } = data

        const pointsMap = this.buildPointsMap(data)
        this.pointsMap = pointsMap

        const issuedMap = {
          registration: issuedRegister,
          email_subscription: issuedEmail,
          sms_subscription: issuedSms,
          birthday: issuedFillBirthday,
        }
        this.issuedMap = issuedMap

        this.querySelectorAll("li[data-type]").forEach((li) => {
          const { type, completeText } = li.dataset
          if (hasTypes && !types.includes(type)) return

          const loggedBtns = li.querySelector("[data-logged-btn]")

          if (loggedBtns && Object.prototype.hasOwnProperty.call(issuedMap, type)) {
            if (issuedMap[type]) {
              this.setCompletedButton(loggedBtns, completeText)
            } else {
              this.showLoggedButton(loggedBtns)
            }
          }
        })

        this.fillBenefitSlots(pointsMap)

        if (!hasTypes) {
          break
        }

        const allCompleted = types.every((type) => issuedMap[type])
        if (allCompleted) {
          break
        }

        if (attempt < maxAttempts) {
          await delay(2000)
        }
      }
    }
    buildPointsMap(data) {
      return {
        registration: [data.registerPoint],
        email_subscription: [data.emailPoint],
        sms_subscription: [data.smsPoint],
        birthday: [data.fillBirthdayPoint, data.birthdayEveryYearPoint],
        warranty: [data.warrantyPoint],
        shop_and_earn: [data.orderCountPoint, data.orderCount, data.orderAmountPoint, data.orderAmount],
      }
    }
    fillBenefitSlots(pointsMap) {
      this.querySelectorAll("li[data-type]").forEach((li) => {
        const type = li.dataset.type
        const values = pointsMap[type]
        if (!values) return

        li.querySelectorAll(".v5-benefit-desc-slot").forEach((slot) => {
          slot.classList.remove("skeleton")
          slot.classList.add("loaded")
          const index = Number(slot.dataset.index || 0)
          if (values[index] != null) {
            slot.textContent = values[index]
          }
        })
      })
    }
    setCompletedButton(container, completeText) {
      if (!container) return
      container.innerHTML = `
        <div class="flex items-center font-semibold text-white bg-[#242F20] px-2 h-[1.75rem] gap-x-1 text-xs lg:gap-x-2 lg:text-base">
          <span>${completeText}</span>
          <svg class="text-white w-2.5 h-2.5 lg:w-4 lg:h-4" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_10795_24255)">
              <path d="M0.726562 8.28842L5.21725 12.7791L15.1966 2.7998" stroke="white" stroke-width="2" stroke-linecap="round"/>
            </g>
            <defs>
              <clipPath id="clip0_10795_24255">
                <rect width="16" height="16" fill="white"/>
              </clipPath>
            </defs>
          </svg>
        </div>
      `
    }
    showLoggedButton(container) {
      if (!container) return
      const skeleton = container.querySelector(".skeleton")
      if (skeleton) skeleton.remove()
      const link = container.querySelector("jds-button")
      if (link) link.classList.remove("hidden")
    }
  })
}
